export interface SkillInterface {
    category: string,
    subcategory: string,
    projects: ProjectInterface[],
    extraNotes: string,
}

export interface EducationInterface {
    institute: string,
    degree: string,
    passoutYear: number,
}

export interface WorkExInterface {
    company: string,
    designation: string,
    employmentType: string,
    startDate: Date,
    endDate?: Date,
    currentlyWorking?: boolean,
}

export interface LocationInterface {
    country: string,
    state: string,
    region: string,
    pincode: number,
    languages: string[],
}

export interface PaymentInterface {
    paymentMethod: string,
    paymentDetails: string,  
    isDefault?: boolean,
}

export interface ProjectInterface {
    projectTitle: string,
    projectDescription: string,
    startDate: Date,
    endDate: Date,
    projectLink: string
}

export interface CertificateInterface {
    name: string,
    issuedBy: string,
    type: string,
    issuedYear: number,
    certificateFile: string,
    certificateLink: string
}

export interface PlanDetailsInterface {
    plan: string | any,
    expiryTimeStamp: Date
}

export interface SellerInterface {
    id: string,
    fullName: string,
    email: string,
    occupation: string,
    personalDescription: string,
    tagline: string,
    location: LocationInterface,
    education: EducationInterface[],
    workExperience?: WorkExInterface[],
    skills?: SkillInterface[],
    paymentDetails?: PaymentInterface[],
    certificates?: CertificateInterface[],
    gender: string,
    contactNumber: string,
    profileImage?: string,
    profileImageAssetId?: string,
    coverImage?: string,
    coverImageAssetId?: string,
    dateOfBirth: string,
    aadharNumber?: string,
    userVerified: boolean,
    userAgreement: boolean,
    buyer?: any,
    planDetails?: PlanDetailsInterface,
    createdAt?: Date
}

export class Seller implements SellerInterface {
    id: string
    fullName: string
    email: string
    occupation: string
    personalDescription: string
    tagline: string
    location: LocationInterface
    education: EducationInterface[] = []
    workExperience?: WorkExInterface[] | undefined = []
    skills?: SkillInterface[] | undefined = []
    paymentDetails?: PaymentInterface[] | undefined = []
    certificates?: CertificateInterface[] | undefined = []
    gender: string
    contactNumber: string
    profileImage?: string
    profileImageAssetId?: string
    coverImage?: string
    coverImageAssetId?: string
    dateOfBirth: string
    aadharNumber?: string
    userVerified: boolean
    userAgreement: boolean
    buyer?: any
    planDetails?: PlanDetailsInterface
    createdAt?: Date

    public constructor(jsonData: any) {
        this.id = jsonData._id
        this.fullName = jsonData.fullName
        this.email = jsonData.email
        this.occupation = jsonData.occupation
        this.personalDescription = jsonData.personalDescription
        this.tagline = jsonData.tagline
        this.location = jsonData.location as LocationInterface
        this.education = jsonData.education as EducationInterface[]
        this.workExperience = jsonData.workExperience as WorkExInterface[]
        this.skills = jsonData.skills as SkillInterface[]
        this.paymentDetails = jsonData.paymentDetails as PaymentInterface[]
        this.gender = jsonData.gender
        this.contactNumber = jsonData.contactNumber
        this.profileImage = jsonData.profileImage
        this.profileImageAssetId = jsonData.profileImageAssetId
        this.coverImage = jsonData.coverImage
        this.coverImageAssetId = jsonData.coverImageAssetId
        this.dateOfBirth = jsonData.dateOfBirth
        this.aadharNumber = jsonData.aadharNumber
        this.userVerified = jsonData.userVerified
        this.userAgreement = jsonData.userAgreement
        this.buyer = jsonData.buyer
        this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
        this.planDetails = jsonData.planDetails as PlanDetailsInterface | undefined
    }

}